import { makeVar, useReactiveVar } from "@apollo/client";

export const selectedModelVariable = makeVar<string | null>(null);

export const useSelectedModel = () => useReactiveVar(selectedModelVariable);
